<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t('batch_job.edit_title')}}</h3>
      </div>

      <form class="form-horizontal">
        <div class="box-body">
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{$t('batch_job.job_name')}}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <input 
                :disabled="this.GET_ACCOUNT_DATA.id != 1"
                v-model="batch_job_data.job_name"
                type="text"
                class="form-control"
                :placeholder="$t('batch_job.job_name')"
              />
            </div>
          </div>
          <!-- end job_name -->

          <div class="form-group">
            <label
              class="col-sm-3 col-md-3 col-lg-3 control-label"
            >{{$t('batch_job.job_description')}}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <input
                :disabled="this.GET_ACCOUNT_DATA.id != 1"
                v-model="batch_job_data.job_description"
                type="text"
                class="form-control"
                :placeholder="$t('batch_job.job_description')"
              />
            </div>
          </div>
          <!-- end job_description -->

          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label"
            >{{$t('batch_job.job_status')}}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <select v-model="batch_job_data.job_status" class="form-control"
               :disabled="batch_job_data.active_status==true"
              >
                <option
                  v-for="status in batchStatus"
                  v-bind:value="status.id"
                  :key="status.id"
                >{{ $t(status.text) }}</option>
              </select>
            </div>
          </div>
          <!-- end job_status -->

          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label"
            >{{$t('batch_job.interval')}}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <select v-model="batch_job_data.interval" class="form-control"
               :disabled="batch_job_data.active_status==true"
              >
                <option
                  v-for="options in batchInterval"
                  v-bind:value="options.id"
                  :key="options.id"
                >{{ $t(options.text) }}</option>
              </select>
            </div>
          </div>
          <!-- end interval -->

          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{$t('batch_job.start_date')}}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <date-picker
              :disabled="batch_job_data.active_status==true"
                class="form-control"
                v-model="batch_job_data.start_date"
                :config="options"
                id="start_date"
              ></date-picker>
            </div>
          </div>
          <!-- end start_date -->

          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{$t('batch_job.end_date')}}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <date-picker
              :disabled="batch_job_data.active_status==true"
                class="form-control"
                v-model="batch_job_data.end_date"
                :config="options"
                id="end_date"
              ></date-picker>
            </div>
          </div>
          <!-- end end_date -->
        </div>
      </form>
    </div>

    <!-- /.box-body -->
    <div class="box-footer">
      <button
        type="button"
        class="btn btn-labeled btn-danger"
        @click="Cancel"
        style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
      >
        <span class="btn-label">
          <i class="fa fa-mail-reply"></i>
        </span>
        {{$t('common.back')}}
      </button>
      <button
       v-if="batch_job_data.active_status==false"
        type="button"
        class="btn btn-labeled btn-success pull-right"
        @click="Save"
        style="margin-right: 5px;"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-ok"></i>
        </span>
        {{$t('common.save')}}
      </button>

       <button
         v-else
          type="button"
          class="btn btn-labeled btn-danger pull-right"
          @click="CancelRunJob"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{$t('common.cancel')}}
        </button>
    </div>

    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
    <router-view></router-view>
  </div>
</template>

<script>
// import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";
// import i18n from "../../lang";
// import constantsData from "../../lib/constantsData";
import BatchStatusEnum from "@/enum/batchStatusEnum";
import BatchIntervalEnum from "@/enum/batchIntervalEnum";

export default {
  name: "BatchJobAdd",
  data() {
    return {
      batch_job_data: {
        id: 0,
        job_name: "",
        job_description: "",
        job_status: BatchStatusEnum.DEACTIVATED,
        active_status: false,
        interval: "",
        start_date: "",
        end_date: "",
        user_updated_id : ""
      },

      isLoading: false,

      batchStatus: [
        { text: "batch_status.Deactivated", id: BatchStatusEnum.DEACTIVATED },
        { text: "batch_status.Activated", id: BatchStatusEnum.ACTIVATED }
      ],

      batchInterval: [
        { text: "batch_interval.Immediately", id: BatchIntervalEnum.IMMEDIATELY },
        { text: "batch_interval.Every_Five_Minutes", id: BatchIntervalEnum.EVERY_FIVE_MINUTES },
        { text: "batch_interval.Every_Hour", id: BatchIntervalEnum.EVERY_HOUR },
        { text: "batch_interval.Daily", id: BatchIntervalEnum.DAILY },
        { text: "batch_interval.Weekly", id: BatchIntervalEnum.WEEKLY }
      ],

      options: {
        format: "DD-MM-YYYY",
        useCurrent: false
      }
    };
  },
  watch: {
    GET_BATCH_JOB_DETAIL_DATA: function() {
      this.batch_job_data = this.GET_BATCH_JOB_DETAIL_DATA;
      if (this.batch_job_data.job_status == BatchStatusEnum.DEACTIVATED)
      {
        this.batch_job_data.active_status = true
      }
      else {
        this.batch_job_data.active_status = false
      }
    }
  },
  computed: {
    ...mapGetters([
      "INVOICE_DETAIL_DATA",
      "GET_SNACK_BAR",
      "GET_BATCH_JOB_DETAIL_DATA",
      "GET_LANG",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "UPDATE_BATCH_JOB",
      "GET_BATCH_JOB_DETAIL"
    ]),

    Cancel: function() {
      this.$router.push({
        name: "BatchJobList"
      });
    },

    checkForm: function() {
      return "OK";
    },
     CancelRunJob:function(){
       this.isLoading = true;
      // [loitt] - changed validate data #266
      let result = this.checkForm(); // validateData
      if (result == "OK") {
        // result = this.validateData();
      }

      let start_date = utils.formatSqlDate(this.batch_job_data.start_date, "DD-MM-YYYY", "YYYY-MM-DDTHH:mm:ss.sssZ");
      let end_date = utils.formatSqlDate(this.batch_job_data.end_date, "DD-MM-YYYY", "YYYY-MM-DDTHH:mm:ss.sssZ");

      let data = {
        id: this.batch_job_data.id,
        job_name: this.batch_job_data.job_name,
        job_description: this.batch_job_data.job_description,
        job_status: BatchStatusEnum.DEACTIVATED,
        interval: this.batch_job_data.interval,
        start_date: start_date,
        end_date: end_date,
        user_updated_id: this.GET_ACCOUNT_DATA.id
      };

      if (result == "OK") {
        this.UPDATE_BATCH_JOB(data)
          .then(
            function() {
              this.isLoading = false;
              this.$router.push({ name: "BatchJobList" });
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    Save: function(event) {
      this.isLoading = true;
      // [loitt] - changed validate data #266
      let result = this.checkForm(); // validateData
      if (result == "OK") {
        // result = this.validateData();
      }

      let start_date = utils.formatSqlDate(this.batch_job_data.start_date, "DD-MM-YYYY", "YYYY-MM-DDTHH:mm:ss.sssZ");
      let end_date = utils.formatSqlDate(this.batch_job_data.end_date, "DD-MM-YYYY", "YYYY-MM-DDTHH:mm:ss.sssZ");

      let data = {
        id: this.batch_job_data.id,
        job_name: this.batch_job_data.job_name,
        job_description: this.batch_job_data.job_description,
        job_status: this.batch_job_data.job_status,
        interval: this.batch_job_data.interval,
        start_date: start_date,
        end_date: end_date,
        user_updated_id: this.GET_ACCOUNT_DATA.id
      };

      if (result == "OK") {
        this.UPDATE_BATCH_JOB(data)
          .then(
            function() {
              this.isLoading = false;
              this.$router.push({ name: "BatchJobList" });
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
              this.isLoading = false;
            }.bind(this)
          );
      }
    }
  },

  mounted() {
    let id = this.$route.params.id;
    this.GET_BATCH_JOB_DETAIL({ id: id });
  },
  components: {
    loading: Loading,
    "date-picker": datePicker
  }
};
</script>

<style scoped>
.table-success {
  border-color: #8fd19e;
  background-color: #ddd;
}

.btn-owner {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #337ab7;
  border-color: #2e6da4;
}

.btn-tenant {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #f0ad4e;
  border-color: #eea236;
}

.btn-null {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #5cb85c;
  border-color: #4cae4c;
}

/* Tooltip container */
.tooltip-button {
  display: inline;
  position: relative;
}

.tooltip-button:hover:after {
  background: #333;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  bottom: 26px;
  color: #fff;
  content: attr(title);
  left: 20%;
  padding: 5px 15px;
  position: absolute;
  z-index: 98;
  width: 220px;
}

.tooltip-button:hover:before {
  border: solid;
  border-color: #333 transparent;
  border-width: 6px 6px 0 6px;
  bottom: 20px;
  content: "";
  left: 50%;
  position: absolute;
  z-index: 99;
}
.hidden {
  display: none;
}
.label-darkcyan {
  background-color: darkcyan !important;
}
.label-crimson {
  background-color: crimson !important;
}
.label-darkblue {
  background-color: darkblue !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/BatchJobAdd.vue